import { EVENT_STATUS } from 'global/LiveStreamWidget/constants';
import WidgetHostDetail from './WidgetHostDetail';
import WidgetInfoAction from './WidgetInfoAction';
import { StreamBoxRightWrapper } from './styled';
import PlayerHeader from './PlayerHeader';

interface StreamBoxRightProps {
  event: any;
}

function StreamBoxRight({ event }: StreamBoxRightProps) {
  const {
    host: {
      description,
      name,
      logo_url: logoUrl,
    },
    status,
    title,
  } = event;
  const isLive = status === EVENT_STATUS.LIVE;

  return (
    <StreamBoxRightWrapper>
      <PlayerHeader
        isLive={isLive}
        title={title}
        status={status}
      />
      <WidgetInfoAction
        event={event}
      />
      <WidgetHostDetail
        description={description}
        name={name}
        logoUrl={logoUrl}
      />
    </StreamBoxRightWrapper>
  );
}

export default StreamBoxRight;
